/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-list","1":"route-guide","2":"route-schedule"}[chunkId]||chunkId) + ".chunk." + {"0":"27a65","1":"9c2b9","2":"ccb70"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "B7O8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info":"info__1kNqb"};

/***/ }),

/***/ "FJnM":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _preact = __webpack_require__("KM04");

var _preactSideEffect = __webpack_require__("xToX");

var _preactSideEffect2 = _interopRequireDefault(_preactSideEffect);

var _deepEqual = __webpack_require__("koiw");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__("J4Nk");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__("Qxat");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var HELMET_ATTRIBUTE = "data-preact-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + ">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeHtml + (isSelfClosing ? ">" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsPreactComponent = function generateTitleAsPreactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[key] = attributes[key];
        return obj;
    }, initProps);

    return [(0, _preact.h)(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsPreactComponent = function generateTagsAsPreactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return (0, _preact.h)(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsPreactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsPreactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

/**
 * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
 * @param {String} title: "Title"
 * @param {String} defaultTitle: "Default Title"
 * @param {String} titleTemplate: "MySite.com - %s"
 * @param {Object} titleAttributes: {"itemprop": "name"}
 * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
 * @param {Array} meta: [{"name": "description", "content": "Test description"}]
 * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
 * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
 * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
 * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
 * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
 */
var Helmet = function Helmet(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        _inherits(HelmetWrapper, _Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = _extends({}, nextProps);
                if (!props.children || !props.children.length) {
                    delete props.children;
                }
                return !(0, _deepEqual2.default)(this.props, props);
            }
        }, {
            key: "render",
            value: function render() {
                return (0, _preact.h)(WrappedComponent, this.props);
            }
        }], [{
            key: "canUseDOM",

            // WrappedComponent.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                WrappedComponent.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_preact.Component), _class.peek = WrappedComponent.peek, _class.rewind = function () {
        var mappedState = WrappedComponent.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;

    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;

        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _preactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),

/***/ "J4Nk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-tap-event-plugin/dist/preact-tap-event-plugin.js
var preact_tap_event_plugin = __webpack_require__("Mgcd");
var preact_tap_event_plugin_default = /*#__PURE__*/__webpack_require__.n(preact_tap_event_plugin);

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/guide/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("2g50") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var guide = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/list/index.js

		

		function list_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("LVgF") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var list = (async_default()(list_load));
	
// CONCATENATED MODULE: ./routes/schedule/index.js

		

		function schedule_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("ePD9") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var schedule = (async_default()(schedule_load));
	
// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ../node_modules/preact-feather/dist/index.es.js
var index_es = __webpack_require__("KCRI");

// EXTERNAL MODULE: ./components/navigation/style.css
var navigation_style = __webpack_require__("nBo+");
var navigation_style_default = /*#__PURE__*/__webpack_require__.n(navigation_style);

// CONCATENATED MODULE: ./components/navigation/index.js







var _ref = Object(preact_min["h"])(
	'nav',
	{ 'class': 'tabs is-center is-full' },
	Object(preact_min["h"])(
		match["Link"],
		{ href: '/', activeClassName: 'active' },
		Object(preact_min["h"])(index_es["h" /* Watch */], { 'class': 'icon' }),
		Object(preact_min["h"])(
			'div',
			null,
			'Horarios'
		)
	),
	Object(preact_min["h"])(
		match["Link"],
		{ href: '/list', activeClassName: 'active' },
		Object(preact_min["h"])(index_es["e" /* List */], { 'class': 'icon' }),
		Object(preact_min["h"])(
			'div',
			null,
			'Lista'
		)
	),
	Object(preact_min["h"])(
		match["Link"],
		{ href: '/guide', activeClassName: 'active' },
		Object(preact_min["h"])(index_es["a" /* BookOpen */], { 'class': 'icon' }),
		Object(preact_min["h"])(
			'div',
			null,
			'Gu\xEDa'
		)
	)
);

var navigation_Navigation = function Navigation() {
	return Object(preact_min["h"])(
		'footer',
		{ 'class': navigation_style_default.a.footer + " is-fixed" },
		_ref
	);
};

/* harmony default export */ var navigation = (navigation_Navigation);
// CONCATENATED MODULE: ./components/app.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






preact_tap_event_plugin_default()();

var listData = [{
	id: "families",
	title: "Familias",
	description: "",
	items: ["Orar por las familia y cada individuo.", "Restauración en los hogares y sanidad interior para cada individuo.", "Que permanezcan fuertes en la fe."]
}, {
	id: "next_generation",
	title: "Próxima Generación",
	description: "",
	items: ["Niños: Que tengan un encuentro con Jesús a temprana edad y que puedan fluir en los dones que Dios deposite en sus vidas.", "Jóvenes: Pasión por Jesús, santidad, valentía y éxito en estudios."]
}, {
	id: "pastors",
	title: "Pastores y Líderes",
	description: "",
	items: ["Familias Pastorales: Protección especial para sus hijos.", "Sabiduría de parte de Dios.", "Unción.", "Protección, salud, y provisión."]
}, {
	id: "economy",
	title: "Economía",
	description: "",
	items: ["Oramos por el equipo Financiero: Gustavo, Héctor y Jeikel.", "Que Dios enseñe a cada familia a ser buenos administradores de su economía.", "Romper toda maldición de pobreza en las familias de la Iglesia.", "Que siempre haya un espíritu generoso y obediente en todos.", "Siempre haya recursos económicos en la Iglesia para cada proyecto que Dios ponga en el corazón de los Pastores."]
}, {
	id: "services",
	title: "Servicios",
	description: "Unción, fortaleza, ánimo y creatividad para los que sirven en:",
	items: ["Alabanza", "Zona kids", "Organización", "Departamento técnico", "Equipo de Limpieza", "Los que buscan recursos económicos para la Iglesia."]
}, {
	id: "win",
	title: "Ganar",
	description: "",
	items: ["Que Dios atraiga el fruto maduro, es decir personas que estén verdaderamente necesitadas de Dios.", "Pasión por las almas perdidas.", "Orar para que Dios nos ponga metas y desafíos grandes.", "Orar por estrategias nuevas para cumplir las metas.", "Unción, protección e inspiración para el equipo del departamento del GANAR."]
}, {
	id: "consolidate",
	title: "Consolidar",
	description: "",
	items: ["Que los nuevos convertidos puedan consolidar las decisiones de su nueva vida en Cristo, levantando el escudo de FE sobre sus vidas.", "Pasión por los nuevos convertidos.", "Que podamos cumplir los propósitos de la Universidad de la vida.", "Unción, protección e inspiración para el equipo del departamento del CONSOLIDAR"]
}, {
	id: "disciple",
	title: "Discipular",
	description: "",
	items: ["Pasión por los alumnos de capacitación destino", "Que podamos cumplir los propósitos de capacitación destino", "Unción, protección e inspiración para el equipo del departamento del DISCIPULADO"]
}, {
	id: "send",
	title: "Enviar",
	description: "",
	items: ["Que Dios levante nuevos líderes de célula y se abrán mas hogares.", "Que Dios nos inspire a estructurar y administrar el crecimiento de iglesia norte internacional.", "Unción, protección e inspiración para el equipo del departamento del ENVIAR."]
}, {
	id: "spain",
	title: "España",
	description: "",
	items: ["Por la salvación de España", "Orar por los Dirigentes del País.", "Orar por un despertar en las Iglesias de España."]
}, {
	id: "other",
	title: "Otros Ministerios",
	description: "",
	items: ["Pastores Jose Luis y Esra Barrios en Madrid", "Pastores Lennart y Carolina Torebring en Estocolmo", "Pastores César y Claudia Castellanos en Bogotá"]
}, {
	id: "israel",
	title: "Israel",
	description: "",
	items: ["Pedimos por la Paz de Jerusalem.", "Bendecimos el Gobierno y la Economía de Israel.", "Oramos por el Cuerpo de Cristo en Israel y sus Pastores"]
}];







var app__ref = Object(preact_min["h"])(schedule, { path: '/', data: listData });

var _ref2 = Object(preact_min["h"])(list, { path: '/list/', data: listData });

var _ref3 = Object(preact_min["h"])(guide, { path: '/guide/' });

var _ref4 = Object(preact_min["h"])(navigation, null);

var app_App = function (_Component) {
	_inherits(App, _Component);

	function App() {
		var _temp, _this, _ret;

		_classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleRoute = function (e) {
			_this.currentUrl = e.url;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/** Gets fired when the route changes.
  *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
  *	@param {string} event.url	The newly routed URL
  */


	App.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ id: 'app' },
			Object(preact_min["h"])(Helmet_default.a, {
				link: [{ "rel": "apple-touch-icon", "sizes": "180x180", "href": "/assets/icons/apple-touch-icon.png" }, { "rel": "mask-icon", "href": "/assets/icons/safari-pinned-tab.svg", "color": "#5bbad5" }] }),
			Object(preact_min["h"])(
				'div',
				{ 'class': 'wrapper' },
				Object(preact_min["h"])(
					preact_router_es["Router"],
					{ onChange: this.handleRoute },
					app__ref,
					_ref2,
					_ref3
				)
			),
			_ref4
		);
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



if (typeof window !== "undefined") {
    document.addEventListener("touchstart", function () {}, true);
}

/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KCRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Activity */
/* unused harmony export Airplay */
/* unused harmony export AlertCircle */
/* unused harmony export AlertOctagon */
/* unused harmony export AlertTriangle */
/* unused harmony export AlignCenter */
/* unused harmony export AlignJustify */
/* unused harmony export AlignLeft */
/* unused harmony export AlignRight */
/* unused harmony export Anchor */
/* unused harmony export Aperture */
/* unused harmony export Archive */
/* unused harmony export ArrowDownCircle */
/* unused harmony export ArrowDownLeft */
/* unused harmony export ArrowDownRight */
/* unused harmony export ArrowDown */
/* unused harmony export ArrowLeftCircle */
/* unused harmony export ArrowLeft */
/* unused harmony export ArrowRightCircle */
/* unused harmony export ArrowRight */
/* unused harmony export ArrowUpCircle */
/* unused harmony export ArrowUpLeft */
/* unused harmony export ArrowUpRight */
/* unused harmony export ArrowUp */
/* unused harmony export AtSign */
/* unused harmony export Award */
/* unused harmony export BarChart2 */
/* unused harmony export BarChart */
/* unused harmony export BatteryCharging */
/* unused harmony export Battery */
/* unused harmony export BellOff */
/* unused harmony export Bell */
/* unused harmony export Bluetooth */
/* unused harmony export Bold */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookOpen; });
/* unused harmony export Book */
/* unused harmony export Bookmark */
/* unused harmony export Box */
/* unused harmony export Briefcase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Calendar; });
/* unused harmony export CameraOff */
/* unused harmony export Camera */
/* unused harmony export Cast */
/* unused harmony export CheckCircle */
/* unused harmony export CheckSquare */
/* unused harmony export Check */
/* unused harmony export ChevronDown */
/* unused harmony export ChevronLeft */
/* unused harmony export ChevronRight */
/* unused harmony export ChevronUp */
/* unused harmony export ChevronsDown */
/* unused harmony export ChevronsLeft */
/* unused harmony export ChevronsRight */
/* unused harmony export ChevronsUp */
/* unused harmony export Chrome */
/* unused harmony export Circle */
/* unused harmony export Clipboard */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Clock; });
/* unused harmony export CloudDrizzle */
/* unused harmony export CloudLightning */
/* unused harmony export CloudOff */
/* unused harmony export CloudRain */
/* unused harmony export CloudSnow */
/* unused harmony export Cloud */
/* unused harmony export Code */
/* unused harmony export Codepen */
/* unused harmony export Coffee */
/* unused harmony export Command */
/* unused harmony export Compass */
/* unused harmony export Copy */
/* unused harmony export CornerDownLeft */
/* unused harmony export CornerDownRight */
/* unused harmony export CornerLeftDown */
/* unused harmony export CornerLeftUp */
/* unused harmony export CornerRightDown */
/* unused harmony export CornerRightUp */
/* unused harmony export CornerUpLeft */
/* unused harmony export CornerUpRight */
/* unused harmony export Cpu */
/* unused harmony export CreditCard */
/* unused harmony export Crop */
/* unused harmony export Crosshair */
/* unused harmony export Database */
/* unused harmony export Delete */
/* unused harmony export Disc */
/* unused harmony export DollarSign */
/* unused harmony export DownloadCloud */
/* unused harmony export Download */
/* unused harmony export Droplet */
/* unused harmony export Edit2 */
/* unused harmony export Edit3 */
/* unused harmony export Edit */
/* unused harmony export ExternalLink */
/* unused harmony export EyeOff */
/* unused harmony export Eye */
/* unused harmony export Facebook */
/* unused harmony export FastForward */
/* unused harmony export Feather */
/* unused harmony export FileMinus */
/* unused harmony export FilePlus */
/* unused harmony export FileText */
/* unused harmony export File */
/* unused harmony export Film */
/* unused harmony export Filter */
/* unused harmony export Flag */
/* unused harmony export FolderMinus */
/* unused harmony export FolderPlus */
/* unused harmony export Folder */
/* unused harmony export Frown */
/* unused harmony export Gift */
/* unused harmony export GitBranch */
/* unused harmony export GitCommit */
/* unused harmony export GitMerge */
/* unused harmony export GitPullRequest */
/* unused harmony export Github */
/* unused harmony export Gitlab */
/* unused harmony export Globe */
/* unused harmony export Grid */
/* unused harmony export HardDrive */
/* unused harmony export Hash */
/* unused harmony export Headphones */
/* unused harmony export Heart */
/* unused harmony export HelpCircle */
/* unused harmony export Home */
/* unused harmony export Image */
/* unused harmony export Inbox */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Info; });
/* unused harmony export Instagram */
/* unused harmony export Italic */
/* unused harmony export Layers */
/* unused harmony export Layout */
/* unused harmony export LifeBuoy */
/* unused harmony export Link2 */
/* unused harmony export Link */
/* unused harmony export Linkedin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return List; });
/* unused harmony export Loader */
/* unused harmony export Lock */
/* unused harmony export LogIn */
/* unused harmony export LogOut */
/* unused harmony export Mail */
/* unused harmony export MapPin */
/* unused harmony export Map */
/* unused harmony export Maximize2 */
/* unused harmony export Maximize */
/* unused harmony export Meh */
/* unused harmony export Menu */
/* unused harmony export MessageCircle */
/* unused harmony export MessageSquare */
/* unused harmony export MicOff */
/* unused harmony export Mic */
/* unused harmony export Minimize2 */
/* unused harmony export Minimize */
/* unused harmony export MinusCircle */
/* unused harmony export MinusSquare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Minus; });
/* unused harmony export Monitor */
/* unused harmony export Moon */
/* unused harmony export MoreHorizontal */
/* unused harmony export MoreVertical */
/* unused harmony export Move */
/* unused harmony export Music */
/* unused harmony export Navigation2 */
/* unused harmony export Navigation */
/* unused harmony export Octagon */
/* unused harmony export Package */
/* unused harmony export Paperclip */
/* unused harmony export PauseCircle */
/* unused harmony export Pause */
/* unused harmony export Percent */
/* unused harmony export PhoneCall */
/* unused harmony export PhoneForwarded */
/* unused harmony export PhoneIncoming */
/* unused harmony export PhoneMissed */
/* unused harmony export PhoneOff */
/* unused harmony export PhoneOutgoing */
/* unused harmony export Phone */
/* unused harmony export PieChart */
/* unused harmony export PlayCircle */
/* unused harmony export Play */
/* unused harmony export PlusCircle */
/* unused harmony export PlusSquare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Plus; });
/* unused harmony export Pocket */
/* unused harmony export Power */
/* unused harmony export Printer */
/* unused harmony export Radio */
/* unused harmony export RefreshCcw */
/* unused harmony export RefreshCw */
/* unused harmony export Repeat */
/* unused harmony export Rewind */
/* unused harmony export RotateCcw */
/* unused harmony export RotateCw */
/* unused harmony export Rss */
/* unused harmony export Save */
/* unused harmony export Scissors */
/* unused harmony export Search */
/* unused harmony export Send */
/* unused harmony export Server */
/* unused harmony export Settings */
/* unused harmony export Share2 */
/* unused harmony export Share */
/* unused harmony export ShieldOff */
/* unused harmony export Shield */
/* unused harmony export ShoppingBag */
/* unused harmony export ShoppingCart */
/* unused harmony export Shuffle */
/* unused harmony export Sidebar */
/* unused harmony export SkipBack */
/* unused harmony export SkipForward */
/* unused harmony export Slack */
/* unused harmony export Slash */
/* unused harmony export Sliders */
/* unused harmony export Smartphone */
/* unused harmony export Smile */
/* unused harmony export Speaker */
/* unused harmony export Square */
/* unused harmony export Star */
/* unused harmony export StopCircle */
/* unused harmony export Sun */
/* unused harmony export Sunrise */
/* unused harmony export Sunset */
/* unused harmony export Tablet */
/* unused harmony export Tag */
/* unused harmony export Target */
/* unused harmony export Terminal */
/* unused harmony export Thermometer */
/* unused harmony export ThumbsDown */
/* unused harmony export ThumbsUp */
/* unused harmony export ToggleLeft */
/* unused harmony export ToggleRight */
/* unused harmony export Trash2 */
/* unused harmony export Trash */
/* unused harmony export Trello */
/* unused harmony export TrendingDown */
/* unused harmony export TrendingUp */
/* unused harmony export Triangle */
/* unused harmony export Truck */
/* unused harmony export Tv */
/* unused harmony export Twitter */
/* unused harmony export Type */
/* unused harmony export Umbrella */
/* unused harmony export Underline */
/* unused harmony export Unlock */
/* unused harmony export UploadCloud */
/* unused harmony export Upload */
/* unused harmony export UserCheck */
/* unused harmony export UserMinus */
/* unused harmony export UserPlus */
/* unused harmony export UserX */
/* unused harmony export User */
/* unused harmony export Users */
/* unused harmony export VideoOff */
/* unused harmony export Video */
/* unused harmony export Voicemail */
/* unused harmony export Volume1 */
/* unused harmony export Volume2 */
/* unused harmony export VolumeX */
/* unused harmony export Volume */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Watch; });
/* unused harmony export WifiOff */
/* unused harmony export Wifi */
/* unused harmony export Wind */
/* unused harmony export XCircle */
/* unused harmony export XSquare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return X; });
/* unused harmony export Youtube */
/* unused harmony export ZapOff */
/* unused harmony export Zap */
/* unused harmony export ZoomIn */
/* unused harmony export ZoomOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Activity = function Activity(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "22 12 18 12 15 21 9 3 6 12 2 12"
  }));
};

var Airplay = function Airplay(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "12 15 17 21 7 21 12 15"
  }));
};

var AlertCircle = function AlertCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "16"
  }));
};

var AlertOctagon = function AlertOctagon(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "16"
  }));
};

var AlertTriangle = function AlertTriangle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17"
  }));
};

var AlignCenter = function AlignCenter(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "10",
    x2: "6",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "6",
    x2: "3",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "14",
    x2: "3",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "18",
    x2: "6",
    y2: "18"
  }));
};

var AlignJustify = function AlignJustify(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "10",
    x2: "3",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "6",
    x2: "3",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "14",
    x2: "3",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "18",
    x2: "3",
    y2: "18"
  }));
};

var AlignLeft = function AlignLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "10",
    x2: "3",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "6",
    x2: "3",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "14",
    x2: "3",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "18",
    x2: "3",
    y2: "18"
  }));
};

var AlignRight = function AlignRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "10",
    x2: "7",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "6",
    x2: "3",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "14",
    x2: "3",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "18",
    x2: "7",
    y2: "18"
  }));
};

var Anchor = function Anchor(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "5",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5 12H2a10 10 0 0 0 20 0h-3"
  }));
};

var Aperture = function Aperture(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14.31",
    y1: "8",
    x2: "20.05",
    y2: "17.94"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9.69",
    y1: "8",
    x2: "21.17",
    y2: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7.38",
    y1: "12",
    x2: "13.12",
    y2: "2.06"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9.69",
    y1: "16",
    x2: "3.95",
    y2: "6.06"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14.31",
    y1: "16",
    x2: "2.83",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16.62",
    y1: "12",
    x2: "10.88",
    y2: "21.94"
  }));
};

var Archive = function Archive(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "21 8 21 21 3 21 3 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "3",
    width: "22",
    height: "5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "12",
    x2: "14",
    y2: "12"
  }));
};

var ArrowDownCircle = function ArrowDownCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8 12 12 16 16 12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "16"
  }));
};

var ArrowDownLeft = function ArrowDownLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "7",
    x2: "7",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 17 7 17 7 7"
  }));
};

var ArrowDownRight = function ArrowDownRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7",
    y1: "7",
    x2: "17",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 7 17 17 7 17"
  }));
};

var ArrowDown = function ArrowDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "19 12 12 19 5 12"
  }));
};

var ArrowLeftCircle = function ArrowLeftCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12 8 8 12 12 16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "12",
    x2: "8",
    y2: "12"
  }));
};

var ArrowLeft = function ArrowLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12 19 5 12 12 5"
  }));
};

var ArrowRightCircle = function ArrowRightCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12 16 16 12 12 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
};

var ArrowRight = function ArrowRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12 5 19 12 12 19"
  }));
};

var ArrowUpCircle = function ArrowUpCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 12 12 8 8 12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "8"
  }));
};

var ArrowUpLeft = function ArrowUpLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "17",
    x2: "7",
    y2: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 17 7 7 17 7"
  }));
};

var ArrowUpRight = function ArrowUpRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7",
    y1: "17",
    x2: "17",
    y2: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 7 17 7 17 17"
  }));
};

var ArrowUp = function ArrowUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "5 12 12 5 19 12"
  }));
};

var AtSign = function AtSign(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
  }));
};

var Award = function Award(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "8",
    r: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
  }));
};

var BarChart2 = function BarChart2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "20",
    x2: "18",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "20",
    x2: "6",
    y2: "14"
  }));
};

var BarChart = function BarChart(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "20",
    x2: "18",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "20",
    x2: "6",
    y2: "16"
  }));
};

var BatteryCharging = function BatteryCharging(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "13",
    x2: "23",
    y2: "11"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "11 6 7 12 13 12 9 18"
  }));
};

var Battery = function Battery(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "6",
    width: "18",
    height: "12",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "13",
    x2: "23",
    y2: "11"
  }));
};

var BellOff = function BellOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M8.56 2.9A7 7 0 0 1 19 9v4m-2 4H2a3 3 0 0 0 3-3V9a7 7 0 0 1 .78-3.22M13.73 21a2 2 0 0 1-3.46 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
};

var Bell = function Bell(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"
  }));
};

var Bluetooth = function Bluetooth(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
  }));
};

var Bold = function Bold(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
  }));
};

var BookOpen = function BookOpen(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
  }));
};

var Book = function Book(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
  }));
};

var Bookmark = function Bookmark(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  }));
};

var Box = function Box(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "2.32 6.16 12 11 21.68 6.16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22.76",
    x2: "12",
    y2: "11"
  }));
};

var Briefcase = function Briefcase(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "14",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
  }));
};

var Calendar = function Calendar(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  }));
};

var CameraOff = function CameraOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
  }));
};

var Camera = function Camera(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "13",
    r: "4"
  }));
};

var Cast = function Cast(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "20",
    x2: "2",
    y2: "20"
  }));
};

var CheckCircle = function CheckCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "22 4 12 14.01 9 11.01"
  }));
};

var CheckSquare = function CheckSquare(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 11 12 14 22 4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
  }));
};

var Check = function Check(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "20 6 9 17 4 12"
  }));
};

var ChevronDown = function ChevronDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "6 9 12 15 18 9"
  }));
};

var ChevronLeft = function ChevronLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "15 18 9 12 15 6"
  }));
};

var ChevronRight = function ChevronRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 18 15 12 9 6"
  }));
};

var ChevronUp = function ChevronUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "18 15 12 9 6 15"
  }));
};

var ChevronsDown = function ChevronsDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 13 12 18 17 13"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 6 12 11 17 6"
  }));
};

var ChevronsLeft = function ChevronsLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "11 17 6 12 11 7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "18 17 13 12 18 7"
  }));
};

var ChevronsRight = function ChevronsRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "13 17 18 12 13 7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "6 17 11 12 6 7"
  }));
};

var ChevronsUp = function ChevronsUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 11 12 6 7 11"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 18 12 13 7 18"
  }));
};

var Chrome = function Chrome(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21.17",
    y1: "8",
    x2: "12",
    y2: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3.95",
    y1: "6.06",
    x2: "8.54",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10.88",
    y1: "21.94",
    x2: "15.46",
    y2: "14"
  }));
};

var Circle = function Circle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};

var Clipboard = function Clipboard(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "8",
    y: "2",
    width: "8",
    height: "4",
    rx: "1",
    ry: "1"
  }));
};

var Clock = function Clock(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12 6 12 12 16 14"
  }));
};

var CloudDrizzle = function CloudDrizzle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "19",
    x2: "8",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "13",
    x2: "8",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "19",
    x2: "16",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "13",
    x2: "16",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
  }));
};

var CloudLightning = function CloudLightning(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "13 11 9 17 15 17 11 23"
  }));
};

var CloudOff = function CloudOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
};

var CloudRain = function CloudRain(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "13",
    x2: "16",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "13",
    x2: "8",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
  }));
};

var CloudSnow = function CloudSnow(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "16",
    x2: "8",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "20",
    x2: "8",
    y2: "20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "16",
    x2: "16",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "20",
    x2: "16",
    y2: "20"
  }));
};

var Cloud = function Cloud(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
  }));
};

var Code = function Code(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 18 22 12 16 6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8 6 2 12 8 18"
  }));
};

var Codepen = function Codepen(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "15.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "22 8.5 12 15.5 2 8.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "2 15.5 12 8.5 22 15.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "8.5"
  }));
};

var Coffee = function Coffee(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18 8h1a4 4 0 0 1 0 8h-1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "1",
    x2: "6",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "1",
    x2: "10",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14",
    y1: "1",
    x2: "14",
    y2: "4"
  }));
};

var Command = function Command(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
  }));
};

var Compass = function Compass(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
  }));
};

var Copy = function Copy(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
};

var CornerDownLeft = function CornerDownLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 10 4 15 9 20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 4v7a4 4 0 0 1-4 4H4"
  }));
};

var CornerDownRight = function CornerDownRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "15 10 20 15 15 20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 4v7a4 4 0 0 0 4 4h12"
  }));
};

var CornerLeftDown = function CornerLeftDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "14 15 9 20 4 15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 4h-7a4 4 0 0 0-4 4v12"
  }));
};

var CornerLeftUp = function CornerLeftUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "14 9 9 4 4 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 20h-7a4 4 0 0 1-4-4V4"
  }));
};

var CornerRightDown = function CornerRightDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "10 15 15 20 20 15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 4h7a4 4 0 0 1 4 4v12"
  }));
};

var CornerRightUp = function CornerRightUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "10 9 15 4 20 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 20h7a4 4 0 0 0 4-4V4"
  }));
};

var CornerUpLeft = function CornerUpLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 14 4 9 9 4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 20v-7a4 4 0 0 0-4-4H4"
  }));
};

var CornerUpRight = function CornerUpRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "15 14 20 9 15 4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 20v-7a4 4 0 0 1 4-4h12"
  }));
};

var Cpu = function Cpu(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "9",
    y: "9",
    width: "6",
    height: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "1",
    x2: "9",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "1",
    x2: "15",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "20",
    x2: "9",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "20",
    x2: "15",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "20",
    y1: "9",
    x2: "23",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "20",
    y1: "14",
    x2: "23",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "9",
    x2: "4",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "14",
    x2: "4",
    y2: "14"
  }));
};

var CreditCard = function CreditCard(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "4",
    width: "22",
    height: "16",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "10",
    x2: "23",
    y2: "10"
  }));
};

var Crop = function Crop(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6.13 1L6 16a2 2 0 0 0 2 2h15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M1 6.13L16 6a2 2 0 0 1 2 2v15"
  }));
};

var Crosshair = function Crosshair(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "22",
    y1: "12",
    x2: "18",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "12",
    x2: "2",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "6",
    x2: "12",
    y2: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "18"
  }));
};

var Database = function Database(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("ellipse", {
    cx: "12",
    cy: "5",
    rx: "9",
    ry: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
  }));
};

var Delete = function Delete(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "9",
    x2: "12",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "9",
    x2: "18",
    y2: "15"
  }));
};

var Disc = function Disc(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
};

var DollarSign = function DollarSign(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "1",
    x2: "12",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
  }));
};

var DownloadCloud = function DownloadCloud(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8 17 12 21 16 17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
  }));
};

var Download = function Download(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 10 12 15 17 10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  }));
};

var Droplet = function Droplet(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
  }));
};

var Edit2 = function Edit2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "16 3 21 8 8 21 3 21 3 16 16 3"
  }));
};

var Edit3 = function Edit3(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "14 2 18 6 7 17 3 17 3 13 14 2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "22",
    x2: "21",
    y2: "22"
  }));
};

var Edit = function Edit(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "18 2 22 6 12 16 8 16 8 12 18 2"
  }));
};

var ExternalLink = function ExternalLink(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "15 3 21 3 21 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "14",
    x2: "21",
    y2: "3"
  }));
};

var EyeOff = function EyeOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
};

var Eye = function Eye(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
};

var Facebook = function Facebook(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
  }));
};

var FastForward = function FastForward(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "13 19 22 12 13 5 13 19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "2 19 11 12 2 5 2 19"
  }));
};

var Feather = function Feather(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "8",
    x2: "2",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17.5",
    y1: "15",
    x2: "9",
    y2: "15"
  }));
};

var FileMinus = function FileMinus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "14 2 14 8 20 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "15",
    x2: "15",
    y2: "15"
  }));
};

var FilePlus = function FilePlus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "14 2 14 8 20 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "15",
    x2: "15",
    y2: "15"
  }));
};

var FileText = function FileText(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "14 2 14 8 20 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "13",
    x2: "8",
    y2: "13"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "17",
    x2: "8",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "10 9 9 9 8 9"
  }));
};

var File = function File(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "13 2 13 9 20 9"
  }));
};

var Film = function Film(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "2.18",
    ry: "2.18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7",
    y1: "2",
    x2: "7",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "2",
    x2: "17",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "7",
    x2: "7",
    y2: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "17",
    x2: "7",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "17",
    x2: "22",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "7",
    x2: "22",
    y2: "7"
  }));
};

var Filter = function Filter(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
  }));
};

var Flag = function Flag(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "22",
    x2: "4",
    y2: "15"
  }));
};

var FolderMinus = function FolderMinus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "14",
    x2: "15",
    y2: "14"
  }));
};

var FolderPlus = function FolderPlus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "11",
    x2: "12",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "14",
    x2: "15",
    y2: "14"
  }));
};

var Folder = function Folder(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }));
};

var Frown = function Frown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 16s-1.5-2-4-2-4 2-4 2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "9",
    x2: "9.01",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "9",
    x2: "15.01",
    y2: "9"
  }));
};

var Gift = function Gift(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "20 12 20 22 4 22 4 12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
  }));
};

var GitBranch = function GitBranch(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "3",
    x2: "6",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18",
    cy: "6",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6",
    cy: "18",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18 9a9 9 0 0 1-9 9"
  }));
};

var GitCommit = function GitCommit(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1.05",
    y1: "12",
    x2: "7",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17.01",
    y1: "12",
    x2: "22.96",
    y2: "12"
  }));
};

var GitMerge = function GitMerge(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18",
    cy: "18",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6",
    cy: "6",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6 21V9a9 9 0 0 0 9 9"
  }));
};

var GitPullRequest = function GitPullRequest(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18",
    cy: "18",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6",
    cy: "6",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M13 6h3a2 2 0 0 1 2 2v7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "9",
    x2: "6",
    y2: "21"
  }));
};

var Github = function Github(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
  }));
};

var Gitlab = function Gitlab(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
  }));
};

var Globe = function Globe(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
  }));
};

var Grid = function Grid(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7"
  }));
};

var HardDrive = function HardDrive(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "22",
    y1: "12",
    x2: "2",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "16",
    x2: "6",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "16",
    x2: "10",
    y2: "16"
  }));
};

var Hash = function Hash(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "9",
    x2: "20",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "15",
    x2: "20",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "3",
    x2: "8",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "3",
    x2: "14",
    y2: "21"
  }));
};

var Headphones = function Headphones(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M3 18v-6a9 9 0 0 1 18 0v6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
  }));
};

var Heart = function Heart(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
  }));
};

var HelpCircle = function HelpCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17"
  }));
};

var Home = function Home(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 22 9 12 15 12 15 22"
  }));
};

var Image = function Image(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "21 15 16 10 5 21"
  }));
};

var Inbox = function Inbox(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "22 12 16 12 14 15 10 15 8 12 2 12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
  }));
};

var Info = function Info(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "8"
  }));
};

var Instagram = function Instagram(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "5",
    ry: "5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17.5",
    y1: "6.5",
    x2: "17.5",
    y2: "6.5"
  }));
};

var Italic = function Italic(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "19",
    y1: "4",
    x2: "10",
    y2: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14",
    y1: "20",
    x2: "5",
    y2: "20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "4",
    x2: "9",
    y2: "20"
  }));
};

var Layers = function Layers(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "12 2 2 7 12 12 22 7 12 2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "2 17 12 22 22 17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "2 12 12 17 22 12"
  }));
};

var Layout = function Layout(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "9",
    x2: "21",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "21",
    x2: "9",
    y2: "9"
  }));
};

var LifeBuoy = function LifeBuoy(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.93",
    y1: "4.93",
    x2: "9.17",
    y2: "9.17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14.83",
    y1: "14.83",
    x2: "19.07",
    y2: "19.07"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14.83",
    y1: "9.17",
    x2: "19.07",
    y2: "4.93"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14.83",
    y1: "9.17",
    x2: "18.36",
    y2: "5.64"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.93",
    y1: "19.07",
    x2: "9.17",
    y2: "14.83"
  }));
};

var Link2 = function Link2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
};

var Link = function Link(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  }));
};

var Linkedin = function Linkedin(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "9",
    width: "4",
    height: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "4",
    cy: "4",
    r: "2"
  }));
};

var List = function List(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "6",
    x2: "21",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "21",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "18",
    x2: "21",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "6",
    x2: "3",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "12",
    x2: "3",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "18",
    x2: "3",
    y2: "18"
  }));
};

var Loader = function Loader(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.93",
    y1: "4.93",
    x2: "7.76",
    y2: "7.76"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16.24",
    y1: "16.24",
    x2: "19.07",
    y2: "19.07"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "12",
    x2: "6",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "12",
    x2: "22",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.93",
    y1: "19.07",
    x2: "7.76",
    y2: "16.24"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16.24",
    y1: "7.76",
    x2: "19.07",
    y2: "4.93"
  }));
};

var Lock = function Lock(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  }));
};

var LogIn = function LogIn(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "10 17 15 12 10 7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "12",
    x2: "3",
    y2: "12"
  }));
};

var LogOut = function LogOut(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 17 21 12 16 7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "12",
    x2: "9",
    y2: "12"
  }));
};

var Mail = function Mail(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "22,6 12,13 2,6"
  }));
};

var MapPin = function MapPin(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "10",
    r: "3"
  }));
};

var Map = function Map(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "6",
    x2: "16",
    y2: "22"
  }));
};

var Maximize2 = function Maximize2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "15 3 21 3 21 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 21 3 21 3 15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "3",
    x2: "14",
    y2: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  }));
};

var Maximize = function Maximize(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
  }));
};

var Meh = function Meh(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "15",
    x2: "16",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "9",
    x2: "9.01",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "9",
    x2: "15.01",
    y2: "9"
  }));
};

var Menu = function Menu(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "18",
    x2: "21",
    y2: "18"
  }));
};

var MessageCircle = function MessageCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }));
};

var MessageSquare = function MessageSquare(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
  }));
};

var MicOff = function MicOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "23",
    x2: "16",
    y2: "23"
  }));
};

var Mic = function Mic(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19 10v2a7 7 0 0 1-14 0v-2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "23",
    x2: "16",
    y2: "23"
  }));
};

var Minimize2 = function Minimize2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "4 14 10 14 10 20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "20 10 14 10 14 4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14",
    y1: "10",
    x2: "21",
    y2: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  }));
};

var Minimize = function Minimize(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
  }));
};

var MinusCircle = function MinusCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
};

var MinusSquare = function MinusSquare(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
};

var Minus = function Minus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }));
};

var Monitor = function Monitor(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "14",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "21",
    x2: "16",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "21"
  }));
};

var Moon = function Moon(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
  }));
};

var MoreHorizontal = function MoreHorizontal(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "5",
    cy: "12",
    r: "1"
  }));
};

var MoreVertical = function MoreVertical(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "5",
    r: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  }));
};

var Move = function Move(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "5 9 2 12 5 15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 5 12 2 15 5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "15 19 12 22 9 19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "19 9 22 12 19 15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "22"
  }));
};

var Music = function Music(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M9 17H5a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm12-2h-4a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "9 17 9 5 21 3 21 15"
  }));
};

var Navigation2 = function Navigation2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "12 2 19 21 12 17 5 21 12 2"
  }));
};

var Navigation = function Navigation(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "3 11 22 2 13 21 11 13 3 11"
  }));
};

var Octagon = function Octagon(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }));
};

var Package = function Package(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "2.32 6.16 12 11 21.68 6.16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "22.76",
    x2: "12",
    y2: "11"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7",
    y1: "3.5",
    x2: "17",
    y2: "8.5"
  }));
};

var Paperclip = function Paperclip(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
  }));
};

var PauseCircle = function PauseCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "15",
    x2: "10",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14",
    y1: "15",
    x2: "14",
    y2: "9"
  }));
};

var Pause = function Pause(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "6",
    y: "4",
    width: "4",
    height: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "14",
    y: "4",
    width: "4",
    height: "16"
  }));
};

var Percent = function Percent(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "19",
    y1: "5",
    x2: "5",
    y2: "19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "2.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "2.5"
  }));
};

var PhoneCall = function PhoneCall(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};

var PhoneForwarded = function PhoneForwarded(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "19 1 23 5 19 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "5",
    x2: "23",
    y2: "5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};

var PhoneIncoming = function PhoneIncoming(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 2 16 8 22 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "1",
    x2: "16",
    y2: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};

var PhoneMissed = function PhoneMissed(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "1",
    x2: "17",
    y2: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "1",
    x2: "23",
    y2: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};

var PhoneOff = function PhoneOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "1",
    x2: "1",
    y2: "23"
  }));
};

var PhoneOutgoing = function PhoneOutgoing(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "23 7 23 1 17 1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16",
    y1: "8",
    x2: "23",
    y2: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};

var Phone = function Phone(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};

var PieChart = function PieChart(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21.21 15.89A10 10 0 1 1 8 2.83"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22 12A10 10 0 0 0 12 2v10z"
  }));
};

var PlayCircle = function PlayCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "10 8 16 12 10 16 10 8"
  }));
};

var Play = function Play(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "5 3 19 12 5 21 5 3"
  }));
};

var PlusCircle = function PlusCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
};

var PlusSquare = function PlusSquare(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
};

var Plus = function Plus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }));
};

var Pocket = function Pocket(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8 10 12 14 16 10"
  }));
};

var Power = function Power(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M18.36 6.64a9 9 0 1 1-12.73 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "12"
  }));
};

var Printer = function Printer(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "6 9 6 2 18 2 18 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "6",
    y: "14",
    width: "12",
    height: "8"
  }));
};

var Radio = function Radio(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
  }));
};

var RefreshCcw = function RefreshCcw(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "1 4 1 10 7 10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "23 20 23 14 17 14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
  }));
};

var RefreshCw = function RefreshCw(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "23 4 23 10 17 10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "1 20 1 14 7 14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
  }));
};

var Repeat = function Repeat(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 1 21 5 17 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M3 11V9a4 4 0 0 1 4-4h14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 23 3 19 7 15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 13v2a4 4 0 0 1-4 4H3"
  }));
};

var Rewind = function Rewind(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "11 19 2 12 11 5 11 19"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "22 19 13 12 22 5 22 19"
  }));
};

var RotateCcw = function RotateCcw(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "1 4 1 10 7 10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
  }));
};

var RotateCw = function RotateCw(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "23 4 23 10 17 10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
  }));
};

var Rss = function Rss(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 11a9 9 0 0 1 9 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 4a16 16 0 0 1 16 16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "5",
    cy: "19",
    r: "1"
  }));
};

var Save = function Save(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 21 17 13 7 13 7 21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "7 3 7 8 15 8"
  }));
};

var Scissors = function Scissors(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6",
    cy: "6",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6",
    cy: "18",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "20",
    y1: "4",
    x2: "8.12",
    y2: "15.88"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14.47",
    y1: "14.48",
    x2: "20",
    y2: "20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8.12",
    y1: "8.12",
    x2: "12",
    y2: "12"
  }));
};

var Search = function Search(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }));
};

var Send = function Send(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "22",
    y1: "2",
    x2: "11",
    y2: "13"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "22 2 15 22 11 13 2 9 22 2"
  }));
};

var Server = function Server(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "8",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "14",
    width: "20",
    height: "8",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "6",
    x2: "6",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "18",
    x2: "6",
    y2: "18"
  }));
};

var Settings = function Settings(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  }));
};

var Share2 = function Share2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18",
    cy: "5",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18",
    cy: "19",
    r: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8.59",
    y1: "13.51",
    x2: "15.42",
    y2: "17.49"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15.41",
    y1: "6.51",
    x2: "8.59",
    y2: "10.49"
  }));
};

var Share = function Share(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 6 12 2 8 6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "15"
  }));
};

var ShieldOff = function ShieldOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
};

var Shield = function Shield(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
  }));
};

var ShoppingBag = function ShoppingBag(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 10a4 4 0 0 1-8 0"
  }));
};

var ShoppingCart = function ShoppingCart(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "9",
    cy: "21",
    r: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "20",
    cy: "21",
    r: "1"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
  }));
};

var Shuffle = function Shuffle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 3 21 3 21 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "20",
    x2: "21",
    y2: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "21 16 21 21 16 21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "15",
    x2: "21",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "4",
    x2: "9",
    y2: "9"
  }));
};

var Sidebar = function Sidebar(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "3",
    x2: "9",
    y2: "21"
  }));
};

var SkipBack = function SkipBack(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "19 20 9 12 19 4 19 20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "5",
    y1: "19",
    x2: "5",
    y2: "5"
  }));
};

var SkipForward = function SkipForward(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "5 4 15 12 5 20 5 4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "19",
    y1: "5",
    x2: "19",
    y2: "19"
  }));
};

var Slack = function Slack(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22.08 9C19.81 1.41 16.54-.35 9 1.92S-.35 7.46 1.92 15 7.46 24.35 15 22.08 24.35 16.54 22.08 9z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12.57",
    y1: "5.99",
    x2: "16.15",
    y2: "16.39"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7.85",
    y1: "7.61",
    x2: "11.43",
    y2: "18.01"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "16.39",
    y1: "7.85",
    x2: "5.99",
    y2: "11.43"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18.01",
    y1: "12.57",
    x2: "7.61",
    y2: "16.15"
  }));
};

var Slash = function Slash(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.93",
    y1: "4.93",
    x2: "19.07",
    y2: "19.07"
  }));
};

var Sliders = function Sliders(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "21",
    x2: "4",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "10",
    x2: "4",
    y2: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "20",
    y1: "21",
    x2: "20",
    y2: "16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "20",
    y1: "12",
    x2: "20",
    y2: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "14",
    x2: "7",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "8",
    x2: "15",
    y2: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "16",
    x2: "23",
    y2: "16"
  }));
};

var Smartphone = function Smartphone(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "5",
    y: "2",
    width: "14",
    height: "20",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "18"
  }));
};

var Smile = function Smile(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "9",
    x2: "9.01",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "9",
    x2: "15.01",
    y2: "9"
  }));
};

var Speaker = function Speaker(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "4",
    y: "2",
    width: "16",
    height: "20",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "14",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "6",
    x2: "12",
    y2: "6"
  }));
};

var Square = function Square(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }));
};

var Star = function Star(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
  }));
};

var StopCircle = function StopCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "9",
    y: "9",
    width: "6",
    height: "6"
  }));
};

var Sun = function Sun(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "1",
    x2: "12",
    y2: "3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.22",
    y1: "4.22",
    x2: "5.64",
    y2: "5.64"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18.36",
    y1: "18.36",
    x2: "19.78",
    y2: "19.78"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "12",
    x2: "3",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "12",
    x2: "23",
    y2: "12"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.22",
    y1: "19.78",
    x2: "5.64",
    y2: "18.36"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18.36",
    y1: "5.64",
    x2: "19.78",
    y2: "4.22"
  }));
};

var Sunrise = function Sunrise(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M17 18a5 5 0 0 0-10 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.22",
    y1: "10.22",
    x2: "5.64",
    y2: "11.64"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "18",
    x2: "3",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "18",
    x2: "23",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18.36",
    y1: "11.64",
    x2: "19.78",
    y2: "10.22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "22",
    x2: "1",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8 6 12 2 16 6"
  }));
};

var Sunset = function Sunset(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M17 18a5 5 0 0 0-10 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4.22",
    y1: "10.22",
    x2: "5.64",
    y2: "11.64"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "18",
    x2: "3",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "18",
    x2: "23",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18.36",
    y1: "11.64",
    x2: "19.78",
    y2: "10.22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "22",
    x2: "1",
    y2: "22"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 5 12 9 8 5"
  }));
};

var Tablet = function Tablet(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "4",
    y: "2",
    width: "16",
    height: "20",
    rx: "2",
    ry: "2",
    transform: "rotate(180 12 12)"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "18"
  }));
};

var Tag = function Tag(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "7",
    y1: "7",
    x2: "7",
    y2: "7"
  }));
};

var Target = function Target(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  }));
};

var Terminal = function Terminal(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "4 17 10 11 4 5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "19",
    x2: "20",
    y2: "19"
  }));
};

var Thermometer = function Thermometer(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
  }));
};

var ThumbsDown = function ThumbsDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
  }));
};

var ThumbsUp = function ThumbsUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
  }));
};

var ToggleLeft = function ToggleLeft(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "5",
    width: "22",
    height: "14",
    rx: "7",
    ry: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "8",
    cy: "12",
    r: "3"
  }));
};

var ToggleRight = function ToggleRight(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "5",
    width: "22",
    height: "14",
    rx: "7",
    ry: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "16",
    cy: "12",
    r: "3"
  }));
};

var Trash2 = function Trash2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "3 6 5 6 21 6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "14",
    y1: "11",
    x2: "14",
    y2: "17"
  }));
};

var Trash = function Trash(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "3 6 5 6 21 6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }));
};

var Trello = function Trello(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "7",
    y: "7",
    width: "3",
    height: "9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "14",
    y: "7",
    width: "3",
    height: "5"
  }));
};

var TrendingDown = function TrendingDown(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "23 18 13.5 8.5 8.5 13.5 1 6"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 18 23 18 23 12"
  }));
};

var TrendingUp = function TrendingUp(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "23 6 13.5 15.5 8.5 10.5 1 18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 6 23 6 23 12"
  }));
};

var Triangle = function Triangle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }));
};

var Truck = function Truck(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "3",
    width: "15",
    height: "13"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "16 8 20 8 23 11 23 16 16 16 16 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "5.5",
    cy: "18.5",
    r: "2.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18.5",
    cy: "18.5",
    r: "2.5"
  }));
};

var Tv = function Tv(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "15",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 2 12 7 7 2"
  }));
};

var Twitter = function Twitter(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
  }));
};

var Type = function Type(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "4 7 4 4 20 4 20 7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "20",
    x2: "15",
    y2: "20"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "4",
    x2: "12",
    y2: "20"
  }));
};

var Umbrella = function Umbrella(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
  }));
};

var Underline = function Underline(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "4",
    y1: "21",
    x2: "20",
    y2: "21"
  }));
};

var Unlock = function Unlock(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M7 11V7a5 5 0 0 1 9.9-1"
  }));
};

var UploadCloud = function UploadCloud(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 16 12 12 8 16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "21"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "16 16 12 12 8 16"
  }));
};

var Upload = function Upload(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 8 12 3 7 8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "15"
  }));
};

var UserCheck = function UserCheck(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "8.5",
    cy: "7",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "17 11 19 13 23 9"
  }));
};

var UserMinus = function UserMinus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "8.5",
    cy: "7",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "11",
    x2: "17",
    y2: "11"
  }));
};

var UserPlus = function UserPlus(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "8.5",
    cy: "7",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "20",
    y1: "8",
    x2: "20",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "11",
    x2: "17",
    y2: "11"
  }));
};

var UserX = function UserX(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "8.5",
    cy: "7",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "8",
    x2: "23",
    y2: "13"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "8",
    x2: "18",
    y2: "13"
  }));
};

var User = function User(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }));
};

var Users = function Users(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }));
};

var VideoOff = function VideoOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
};

var Video = function Video(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "23 7 16 12 23 17 23 7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "1",
    y: "5",
    width: "15",
    height: "14",
    rx: "2",
    ry: "2"
  }));
};

var Voicemail = function Voicemail(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "5.5",
    cy: "11.5",
    r: "4.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "18.5",
    cy: "11.5",
    r: "4.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "5.5",
    y1: "16",
    x2: "18.5",
    y2: "16"
  }));
};

var Volume1 = function Volume1(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M15.54 8.46a5 5 0 0 1 0 7.07"
  }));
};

var Volume2 = function Volume2(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
  }));
};

var VolumeX = function VolumeX(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "23",
    y1: "9",
    x2: "17",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "17",
    y1: "9",
    x2: "23",
    y2: "15"
  }));
};

var Volume = function Volume(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }));
};

var Watch = function Watch(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "7"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12 9 12 12 13.5 13.5"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
  }));
};

var WifiOff = function WifiOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M10.71 5.05A16 16 0 0 1 22.58 9"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "20"
  }));
};

var Wifi = function Wifi(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M5 12.55a11 11 0 0 1 14.08 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M1.42 9a16 16 0 0 1 21.16 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "20"
  }));
};

var Wind = function Wind(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
  }));
};

var XCircle = function XCircle(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "9",
    x2: "9",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "9",
    x2: "15",
    y2: "15"
  }));
};

var XSquare = function XSquare(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "9",
    y1: "9",
    x2: "15",
    y2: "15"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "15",
    y1: "9",
    x2: "9",
    y2: "15"
  }));
};

var X = function X(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
};

var Youtube = function Youtube(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
    d: "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
  }));
};

var ZapOff = function ZapOff(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "12.41 6.75 13 2 10.57 4.92"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "18.57 12.91 21 10 15.66 10"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", {
    points: "8 8 3 14 12 14 11 22 16 16"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
};

var Zap = function Zap(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", {
    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
  }));
};

var ZoomIn = function ZoomIn(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "11",
    y1: "8",
    x2: "11",
    y2: "14"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "11",
    x2: "14",
    y2: "11"
  }));
};

var ZoomOut = function ZoomOut(props) {
  var color = props.color || 'currentColor';
  var size = props.size || 24;
  delete props.color;
  delete props.size;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, props), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("line", {
    x1: "8",
    y1: "11",
    x2: "14",
    y2: "11"
  }));
};


//# sourceMappingURL=index.es.js.map

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "Mgcd":
/***/ (function(module, exports, __webpack_require__) {

!function (global, factory) {
     true ? module.exports = factory(__webpack_require__("KM04")) : "function" == typeof define && define.amd ? define(["preact"], factory) : global.injectTapEventPlugin = factory(global.preact);
}(this, function (preact) {
    function proxy(attrs) {
        var map = {};
        for (var i in attrs) {
            attrs.hasOwnProperty(i) && (map[i.toLowerCase()] = i);
        }var start = attrs[map.ontouchstart],
            tap = attrs[map.ontouchtap],
            click = attrs[map.onclick];
        delete attrs[map.ontouchtap], attrs[map.onclick || "onClick"] = function (e) {
            if (click && click(e), !hasTouch) return tap(e);
        }, attrs[map.ontouchstart || "onTouchStart"] = function (e) {
            var down = coords(e);
            if (hasTouch = !0, addEventListener("touchend", function onEnd(e) {
                removeEventListener("touchend", onEnd);
                var up = coords(e),
                    dist = Math.sqrt(Math.pow(up.x - down.x, 2) + Math.pow(up.y - down.y, 2));
                dist < OPTS.threshold && tap(e);
            }), start) return start(e);
        };
    }
    function coords(e) {
        var t = e.changedTouches && e.changedTouches[0] || e.touches && e.touches[0] || e;
        return {
            x: t.pageX,
            y: t.pageY,
            target: t.target
        };
    }
    var OPTS = {
        threshold: 10
    },
        injected = void 0,
        hasTouch = void 0,
        index = function index(opts) {
        for (var i in opts) {
            opts.hasOwnProperty(i) && (OPTS[i] = opts[i]);
        }if (!injected) {
            injected = !0;
            var oldHook = preact.options.vnode;
            preact.options.vnode = function (vnode) {
                var attrs = vnode.attributes;
                if (attrs) for (var _i in attrs) {
                    if (attrs.hasOwnProperty(_i) && "ontouchtap" === _i.toLowerCase()) {
                        proxy(attrs);
                        break;
                    }
                }oldHook && oldHook(vnode);
            };
        }
    };
    return index;
});
//# sourceMappingURL=preact-tap-event-plugin.js.map

/***/ }),

/***/ "OWwF":
/***/ (function(module, exports) {

var supportsArgumentsClass = function () {
  return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object) {
  return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
};

/***/ }),

/***/ "Qxat":
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var PREACT_TAG_MAP = exports.PREACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),

/***/ "koiw":
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__("mbYX");
var isArguments = __webpack_require__("OWwF");

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

    // 7.3. Other pairs that do not both pass typeof value == 'object',
    // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

    // 7.4. For all other Object pairs, including Array objects, equivalence is
    // determined by having the same number of owned properties (as verified
    // with Object.prototype.hasOwnProperty.call), the same set of keys
    // (although not necessarily the same order), equivalent values for every
    // corresponding key, and an identical 'prototype' property. Note: this
    // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
};

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {
    //happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length) return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}

/***/ }),

/***/ "mbYX":
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;

exports.shim = shim;
function shim(obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
}

/***/ }),

/***/ "nBo+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__s1zed"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sIAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ../node_modules/preact-feather/dist/index.es.js
var index_es = __webpack_require__("KCRI");

// EXTERNAL MODULE: ./components/header/style.css
var style = __webpack_require__("u3et");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/info/style.css
var info_style = __webpack_require__("B7O8");
var info_style_default = /*#__PURE__*/__webpack_require__.n(info_style);

// CONCATENATED MODULE: ./components/info/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref3 = Object(preact_min["h"])(index_es["d" /* Info */], null);

var _ref4 = Object(preact_min["h"])(
	'h2',
	null,
	Object(preact_min["h"])(index_es["d" /* Info */], null),
	' Intercesi\xF3n'
);

var _ref5 = Object(preact_min["h"])(
	'div',
	{ className: 'info-content' },
	Object(preact_min["h"])(
		'h4',
		null,
		'Verano 2019'
	),
	Object(preact_min["h"])(
		'p',
		null,
		'Este verano vamos a dar inicio a una nueva estrategia de intercesi\xF3n para Iglesia Norte, ya que pensamos que necesitamos que se involucren m\xE1s personas en la intercesi\xF3n de la Iglesia. Hasta ahora hemos sido un grupo bastante fiel y constante que ha llevado sobre sus hombros la carga de la oraci\xF3n e intercesi\xF3n en la iglesia. Ahora es el momento de que la iglesia entera tome su responsabilidad y comencemos nuestro proceso de convirtamos en verdaderos intercesores.'
	),
	Object(preact_min["h"])(
		'p',
		null,
		'Vamos a seguir orando por los mismos puntos que hasta ahora, pero vamos a repartir los puntos de oraci\xF3n en 4 d\xEDas.'
	),
	Object(preact_min["h"])(
		'h4',
		null,
		'Oraci\xF3n de Lunes a Jueves.'
	),
	Object(preact_min["h"])(
		'small',
		null,
		Object(preact_min["h"])(index_es["b" /* Calendar */], null),
		' Lunes - Jueves'
	),
	Object(preact_min["h"])(
		'small',
		null,
		Object(preact_min["h"])(index_es["c" /* Clock */], null),
		' 10 min'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Se repartir\xE1n estos d\xEDas por c\xE9lulas, as\xED que a cada c\xE9lula le corresponder\xE1 orar un d\xEDa especifico.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Se ora en casa.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'La oraci\xF3n ser\xE1 de 10 minutos.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Hay tres horarios a los que unirse en oraci\xF3n: 22:00, 23:00 y 00:00.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Cada persona escoge el horario que mejor le convenga.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Cuando se haya terminado de orar, se le comunica al l\xEDder de c\xE9lula.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'El l\xEDder de c\xE9lula comunicar\xE1 el n\xFAmero de personas que han orado ese d\xEDa a la persona asignada del departamento del Ganar que recoger\xE1 los datos.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'EL recuento es para saber si la iglesia est\xE1 realmente intercediendo por todas los puntos, y si no, poder remediarlo.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Los puntos a orar se repartir\xE1n por d\xEDas: Ej: Lunes: Oramos por Pastores, Liderazgo y Familias.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Los puntos a orar ir\xE1n rotando cada mes. De esta manera a las c\xE9lulas les tocar\xE1 orar por diferentes puntos cada mes.'
		)
	),
	Object(preact_min["h"])(
		'h4',
		null,
		'Monta\xF1a de Oraci\xF3n'
	),
	Object(preact_min["h"])(
		'small',
		null,
		Object(preact_min["h"])(index_es["b" /* Calendar */], null),
		' Viernes'
	),
	Object(preact_min["h"])(
		'small',
		null,
		Object(preact_min["h"])(index_es["c" /* Clock */], null),
		' 20:00 - 21:00'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Todos los Viernes de 20:00-21:00 oraremos juntos en la Iglesia.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Habr\xE1 dos alabanzas, se compartir\xE1 una Palabra Rema y habr\xE1 Intercesi\xF3n por todos los puntos que oramos.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Se responsabilizar\xE1n de las monta\xF1as de oraci\xF3n los equipos de 12 de los Pastores.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'3 Parejas de los equipos de 12 ir\xE1n rotando semana a semana.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Ser\xE1n responsables de toda la reuni\xF3n.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Preparar un equipo t\xE9cnico que pueda encender pantallas y llevar el sonido.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Dos alabanzas con pista.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Una palabra Rema de 5 minutos.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Orar\xE1n por los 12 puntos, reparti\xE9ndose los puntos 2 por cada uno de los l\xEDderes.'
		)
	)
);

var info_InfoModal = function (_Component) {
	_inherits(InfoModal, _Component);

	function InfoModal() {
		var _temp, _this, _ret;

		_classCallCheck(this, InfoModal);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.open = function () {
			return _this.setState({ open: true });
		}, _this.close = function () {
			return _this.setState({ open: false });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	InfoModal.prototype.render = function render(_ref, _ref2) {
		var open = _ref2.open;

		_objectDestructuringEmpty(_ref);

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'pull-right' },
			Object(preact_min["h"])(
				'button',
				{ onClick: this.open },
				_ref3
			),
			open ? Object(preact_min["h"])(
				'div',
				{ 'class': info_style_default.a.info },
				Object(preact_min["h"])(
					'div',
					{ className: 'wrapper' },
					_ref4,
					Object(preact_min["h"])(
						'button',
						{ type: true, button: true, 'class': 'button secondary' },
						Object(preact_min["h"])(index_es["i" /* X */], { onClick: this.close })
					),
					_ref5
				)
			) : null
		);
	};

	return InfoModal;
}(preact_min["Component"]);

/* harmony default export */ var info = (info_InfoModal);
// CONCATENATED MODULE: ./components/header/index.js









var header__ref2 = Object(preact_min["h"])(info, null);

var header_Header = function Header(_ref) {
	var title = _ref.title;
	return Object(preact_min["h"])(
		'header',
		{ 'class': style_default.a.header },
		Object(preact_min["h"])(
			'h1',
			null,
			title
		),
		header__ref2
	);
};

/* harmony default export */ var header = __webpack_exports__["a"] = (header_Header);

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "u3et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI"};

/***/ }),

/***/ "xToX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /** @jsx h */

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        // preact-compat normally does this
        var children = nextProps.children,
            props = _objectWithoutProperties(nextProps, ['children']);

        if (children && children.length) props.children = children;
        return shallowDiffers(props, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return (0, _preact.h)(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_preact.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

    return SideEffect;
  };

  // Pulled from react-compat
  function shallowDiffers(a, b) {
    for (var i in a) {
      if (!(i in b)) return true;
    }for (var _i in b) {
      if (a[_i] !== b[_i]) return true;
    }return false;
  }
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.c6525.js